import styled from 'styled-components';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.surface.high};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: Inter;
  font-size: 12px;
  width: 100%;
  margin-top: 24px;

  @media (max-width: 1200px) {
    width: calc(100% - 48px);
  }
`;
